import React, { useEffect, useState, useRef } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { httpService } from "../../../base/services/httpService.service";
import "./style.scss";
import Toast from "../../../base/components/Toast";
import { useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Avatar, Button, Input, Spin, Upload } from "antd";
import { getFullDateTime } from "../../../base/utils/timezoneConverter";
import { DownloadFile, FileUpload } from "../../../assets/icons";
import * as Yup from "yup";
import { useFilePreview } from "../../admin/survey/surveyBuilder/v2/surveyStore";
import { useTranslation } from "../../../i18n/LanguageContext";
const formInitialValues = {
   text: "",
   files: []
};

const ChatCard = ({ loggedInUser, userName, organizationName, getTicketById, messages }) => {
   const { t } = useTranslation();
   const validationSchema = Yup.object().shape({
      text: Yup.string().required(t("message-required-validation"))
   });
   // const [messages, setMessages] = useState([]);
   const [loading, setLoading] = useState(false);
   const formikRef = useRef(null);
   const [fileList, setFileList] = useState([]);
   
   const messageContainerRef = useRef(null);
   const { loadingFiles, previewFiles } = useFilePreview();

   const { id } = useParams();

   // const getMessages = async () => {
   //    httpService.get(`/Tickets/${id}`, (res) => {
   //       setMessages(res?.data?.messages);
   //    });
   // };

   const handleSendMessage = async (values, actions) => {
      const formData = new FormData();
      formData.append("Text", values.text);
      fileList.forEach((file) => {
         formData.append("Files", file.originFileObj);
      });

      try {
         setLoading(true);
         await httpService.post(`/Tickets/${id}/message`, formData, (res) => {
            if (res?.status === 200) {
               getTicketById();
               actions.resetForm();
               setFileList([]);
            }
         });
      } catch (error) {
         console.log(error);
      } finally {
         actions.setSubmitting(false);
         setLoading(false);
      }
   };

   const handleFileChange = ({ fileList }) => {
      const allowedTypes = ["image/png", "image/jpeg", "image/gif", "image/webp"];
      const filteredList = fileList.filter((file) => allowedTypes.includes(file.type));

      if (filteredList.length !== fileList.length) {
         Toast.error(t("upload-jpg-png-gif-webp-error"));
      }

      setFileList(filteredList.slice(0, 3));

      const attachmentIds = fileList.slice(0, 3).map((file) => file.originFileObj);
      formikRef.current.setFieldValue("Files", attachmentIds);
   };

   const getBase64 = (file) => {
      console.log("File structure:", file);
      return new Promise((resolve, reject) => {
        const fileToRead = file.originFileObj || file;
        if (fileToRead instanceof Blob) {
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        } else {
          reject(new Error("Invalid file format"));
        }
      });
    };

   const getPreviewImage = async (file) => {
      return await getBase64(file);
   };

   useEffect(() => {
      messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
   }, [messages]);

   // useEffect(() => {
   //    getMessages();
   // }, []);

   const sender = messages?.find((msg) => msg?.senderType === 1)?.userName;
   // When the logged-in viewer isn't the ticket's submitter (i.e. an admin/
   // support agent viewing it), the header identifies who filed the ticket -
   // shown as the organization's name (per design) rather than a person's.
   const counterpartName = organizationName || userName;


   const [previewImages, setPreviewImages] = useState([]);
   
  useEffect(() => {
   const loadImages = async () => {
     const previews = await Promise.all(
       fileList.map(async (file) => ({
         id: file,
         url: await getPreviewImage(file),
       }))
     );
     setPreviewImages(previews);
   };
   
   if (fileList?.length) {
     loadImages();
   } else {
      setPreviewImages([]);
   }
 }, [fileList]);

 const deleteUpload = (el) => {
   const newData = fileList?.filter((e) => e.uid !== el?.uid);
   setFileList(newData);
 }
 
   return (
      <div className="ticket-chat-card">
         <div className="ticket-chat-header">
            <span className="svg-icon svg-icon-lg">
               <Avatar className="ticket-chat-avatar">
                  {loggedInUser === userName
                     ? sender?.charAt(0).toUpperCase()
                     : counterpartName?.charAt(0).toUpperCase()}
               </Avatar>
            </span>
            <span className="ticket-chat-header-name">
               {loggedInUser === userName ? sender : counterpartName}
            </span>
         </div>
         <div className="ticket-chat-body" ref={messageContainerRef}>
            {messages?.map((message, index) => {
               return (
                  <>
                     <div
                        className="ticket-message-meta"
                        style={{
                           justifyContent:
                              message?.userName === loggedInUser ? "flex-end" : "flex-start"
                        }}
                     >
                        <Avatar className="ticket-chat-avatar">
                           {message?.userName.charAt(0).toUpperCase()}
                        </Avatar>
                        <p className="ticket-message-author">
                           {message?.userName}{" "}
                           <span className="ticket-message-timestamp">
                              {" "}
                              {getFullDateTime(new Date(message.timestamp)) || "-"}
                           </span>
                        </p>
                     </div>

                     <div
                        key={index}
                        className={
                           message.userName === loggedInUser
                              ? "ticket-message-bubble is-own"
                              : "ticket-message-bubble"
                        }
                     >
                        <p className="ticket-message-text">{message?.message}</p>
                        <div className="inner-card d-flex align-items-center justify-content-between">
                           <div
                              className="inner-content"
                              style={{
                                 width: "100%",
                                 display: "flex",
                                 flexDirection: "column",
                                 gap: "20px"
                              }}
                           >
                              {message?.files &&
                                 message?.files.map((file, index) => (
                                    <>
                                       <div key={index} className="ticket-attachment-item">
                                          <img src={FileUpload} alt="" />
                                          <span className="ticket-attachment-name">{file}</span>
                                       </div>
                                       <div className="ticket-attachment-actions">
                                          <img src={DownloadFile} alt="" />{" "}
                                          <div
                                             onClick={(e) => previewFiles(e, file, message?.id)}
                                             className="ticket-attachment-download"
                                          >
                                             {loadingFiles[file] ? <Spin /> : t("download-action")}
                                          </div>
                                       </div>
                                    </>
                                 ))}
                           </div>
                        </div>
                     </div>
                  </>
               );
            })}
         </div>

         <Formik
            validationSchema={validationSchema}
            innerRef={formikRef}
            onSubmit={(values, actions) => {
               handleSendMessage(values, actions);
            }}
            initialValues={formInitialValues}
         >
            {({
               handleSubmit,
               handleChange,
               touched,
               values,
               errors,
               actions,
               resetForm,
               isSubmitting
            }) => (
               <Form onSubmit={handleSubmit}>
                  <div className="ticket-chat-footer">
                     <div className="ticket-chat-composer">
                        <Input.TextArea
                           name="text"
                           type="text"
                           className="form-control input-ticket-write"
                           placeholder={t("type-your-message-placeholder")}
                           value={values.text}
                           onChange={handleChange}
                           autoComplete="off"
                           autoSize={{ minRows: 1, maxRows: 1 }}
                        />
                        <div className="ticket-chat-composer-actions">
                           <Upload
                              name="files"
                              // listType="picture-card"
                              showUploadList={false}
                              multiple
                              fileList={fileList}
                              onChange={handleFileChange}
                              beforeUpload={(file) => {
                                 if (fileList.length < 3) {
                                    setFileList([...fileList, file]);
                                 }
                                 return false;
                              }}
                              accept=".png, .jpeg, .jpg, .gif, .webp"
                              disabled={isSubmitting || loading}
                              className="ticket-attach-button"
                           >
                              <span className="svg-icon svg-icon-lg">
                                 <SVG
                                    src={toAbsoluteUrl(
                                       "/media/svg/custom-icons/attach_secondColor.svg"
                                    )}
                                 />
                              </span>
                           </Upload>

                           <Button
                              className="ticket-send-button"
                              key="success"
                              htmlType="submit"
                              onClick={handleSubmit}
                              disabled={isSubmitting || loading}
                           >
                              {loading ? (
                                 <Spin />
                              ) : (
                                 <span className="svg-icon svg-icon-lg">
                                    <SVG
                                       src={toAbsoluteUrl(
                                          "/media/svg/custom-icons/sendMessage.svg"
                                       )}
                                    />
                                 </span>
                              )}
                           </Button>
                        </div>
                     </div>
                     <div className="images-to-upload">
                     {
                        previewImages.map(({ id, url }) => (
                           <>
                              <div className="singe-upload-image-wrapper">
                                 <div className="closeOverlay" onClick={() => deleteUpload(id)}>
                                    <span> - </span>
                                 </div>
                                 <img className="img-main" key={id.uid} src={url} alt={`Preview ${id.uid}`} />
                              </div>
                           </>
                           )
                        )
                     }
                     </div>
                     <div className="error-message">{errors.text}</div>
                  </div>
               </Form>
            )}
         </Formik>
      </div>
   );
};

export default ChatCard;
